import React, { useMemo, useEffect, useCallback } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import style from './loyaltyCopy.module.scss';
import LoyaltyLightImg from '@assets/images/loyaltyLight.png';
import LoyaltyImg from '@assets/images/loyalty.png';
import { getObjectValue } from '@utility/utills';
import { TouchableButton } from '@components/common/Touchable';
import PropTypes from 'prop-types';


const LoyaltySignIn = (props) => {
  const {
    loyaltyMethod,
    loyaltyInfo,
    openLoyaltyKeyboard,
    serverAppTheme,
    joinClicked,
    alreadyMem,
    themeProperties,
    handleOrderBackButton,
    isLandScape
  } = props
  const getTheme = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme);

  const signInMethods = useMemo(() => {
    if (loyaltyMethod === 'signIn') {
      return loyaltyInfo.lookupMethods || [];
    } else if (loyaltyMethod === 'signUp') {
      return loyaltyInfo.signUpMethods || [];
    }
    return [];
  }, [loyaltyMethod, loyaltyInfo]);

  useEffect(() => {
    if (signInMethods.length === 1) {
      openLoyaltyKeyboard(signInMethods[0]);
    }
  }, [signInMethods]);

  const handleSignInMethodClick = (data) => {
    openLoyaltyKeyboard(data);
  };

  const handleMethodClick = useCallback((event, item) => {
    event.preventDefault();
    handleSignInMethodClick(item);
  }, [handleSignInMethodClick]);

  const getName = useCallback((methodName) => {
    switch (methodName) {
      case 'phone': return LABEL().OLS_PHONE;
      case 'type': return LABEL().LS_ACCOUNT;
      case 'email': return LABEL().OLS_EMAIL;
      case 'swipe': return LABEL().LOYALTY_SWIPE;
      default: return LABEL().LOYALTY_SCAN;
    }
  }, []);

  return (
    <div className={cn("w-100 position-relative", isLandScape ? "h-95" : "h-97")}>
      {!isLandScape && (
        <div className="w-100 py-1 h-20 pt-2 pb-1">
          {(loyaltyMethod !== "signIn"
            ? themeProperties?.loyaltySignUpImageUrl?.length > 0
            : themeProperties?.loyaltySignInImageUrl?.length > 0) ? (
            <img
              loading="lazy"
              src={
                loyaltyMethod !== "signIn"
                  ? themeProperties?.loyaltySignUpImageUrl
                  : themeProperties?.loyaltySignInImageUrl
              }
              alt="signIn"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              className=""
            />
          ) : getTheme === "2" ? (
            <img
              loading="lazy"
              alt='loyaltyLight'
              src={LoyaltyLightImg}
              style={{ width: "100%", objectFit: "cover" }}
              className="h-100"
            />
          ) : (
            <img
              loading="lazy"
              alt='loyalty'
              src={LoyaltyImg}
              style={{ width: "100%", objectFit: "cover" }}
              className="h-100"
            />
          )}
        </div>
      )}

      <div
        className={cn(
          "row mx-0 p-2 fs-32 justify-content-center",
          isLandScape ? "h-50 align-items-center" : "h-52"
        )}
        style={{ color: serverAppTheme?.primary_text }}
      >
        {/* Title - only show in portrait mode */}
        {!isLandScape && (
          <div className="col-12 px-0 py-2 text-center fs_24 fw-700">
            {joinClicked
              ? LABEL().LS_SIGN_UP_TO_LOYALTY
              : alreadyMem
                ? LABEL().LS_SIGN_IN_TO_LOYALTY
                : ""}
          </div>
        )}

        <div
          className={cn("fw-400 fs_32 p-1 text-center")}
          style={{ color: serverAppTheme?.primary_text }}
        >
          {loyaltyMethod === "signIn"
            ? CUSTOM_MESSAGES().OLS_SIGN_IN_TODAY
            : CUSTOM_MESSAGES().OLS_JOIN_TODAY}
        </div>
      </div>

      <div
        className={cn(
          isLandScape
            ? "col-12 d-flex flex-column align-items-center justify-content-center position-absolute"
            : "w-100 text-center h-30 align-self-end position-absolute d-flex align-items-end"
        )}
        style={isLandScape ? { bottom: "-9px" } : { bottom: "0" }}
      >
        <div className={cn(isLandScape ? "d-flex flex-column align-items-center" : "w-100")}>
          {signInMethods?.map((item, index) => {
            return (
              item &&
              item !== "swipe" &&
              item !== "scan" && (
                <TouchableButton
                  key={item}
                  type="button"
                  onClick={(event) => {
                    handleMethodClick(event, item)
                    event.preventDefault();
                  }}
                  className={cn(
                    style.loyalty_btn,
                    "fw-50 btn-ripple od-primary-btn-bg-color od-primary-btn-font-color mb-2",
                    isLandScape
                      ? ""
                      : cn(style.join_btn_height, "btn70 w-100", index === signInMethods?.length - 1 ? "" : "mb-2")
                  )}
                  style={isLandScape
                    ? { fontFamily: "Poppins", width: "485px", height: "68px" }
                    : { fontFamily: "Poppins", height: "7.5vh" }
                  }
                  rippleEffect={true}
                >
                  <div className={cn("fs_28 fw-600")}>
                    {getName(item)}
                  </div>
                </TouchableButton>
              )
            );
          })}

          <TouchableButton
            type="button"
            className={cn(
              "d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color",
              style.loyalty_btn,
              isLandScape ? "" : "col-12 px-0 mt-2"
            )}
            style={{
              ...(isLandScape
                ? { width: "485px", height: "68px" }
                : { height: "7.5vh" }),
              backgroundColor: serverAppTheme?.OFF_Premise_Btn,
              color: serverAppTheme?.primary_text,
              border: "1px solid #2541A4"
            }}
            onClick={(e) => {
              e.preventDefault();
              handleOrderBackButton();
            }}
            rippleEffect={true}
          >
            <span className="fw-600 fs_28">{LABEL().OLS_CANCEL}</span>
          </TouchableButton>
        </div>
      </div>
    </div>
  );
};

LoyaltySignIn.propTypes = {
  loyaltyMethod: PropTypes.string,            // or oneOf([...]) if enum
  loyaltyInfo: PropTypes.object,               // or shape({...})
  openLoyaltyKeyboard: PropTypes.func,
  serverAppTheme: PropTypes.string,
  joinClicked: PropTypes.bool,
  alreadyMem: PropTypes.bool,
  themeProperties: PropTypes.object,
  handleOrderBackButton: PropTypes.func,
  isLandScape: PropTypes.bool,
};

LoyaltySignIn.defaultProps = {
  loyaltyInfo: {},
  joinClicked: false,
  alreadyMem: false,
  themeProperties: {},
  isLandScape: false,
};
export default React.memo(LoyaltySignIn);